import HiddenPagesList from "../../../../src/partials/HiddenPagesList";
import * as React from 'react';
export default {
  HiddenPagesList,
  React
};